import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-j-unit',
  standalone: true,
  imports: [],
  templateUrl: './j-unit.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './j-unit.component.scss'
})
export class JUnitComponent {

}
